module.exports = __webpack_public_path__ + "img/187.problem_coffee_machine.cd56dcc5.svg";